import { AssignmentSummary } from "../components/scheduling/RecentAssignments";
import { getAssignmentLabel, isAVPart, isMidweekPart, isWeekendPart } from "./conflictDetection";
import { getDayjs, stringToLongLocaleDate } from "./dateHelpers";
import { t } from "./locale";

export const getWeeklyAssignmentSummary = (weekOf: string, weekAssignments: AssignmentSummary[]) => {
  const midweekAssignments = weekAssignments.filter((a) => isMidweekPart(a.type));
  const weekendAssignments = weekAssignments.filter((a) => isWeekendPart(a.type));
  weekAssignments
    .filter((a) => isAVPart(a.type))
    .forEach((av) => {
      const avDate = getDayjs(av.date);
      [6, 0].includes(avDate.day()) ? weekendAssignments.push(av) : midweekAssignments.push(av);
    });
  const otherParts = weekAssignments.filter(
    (a) => !isMidweekPart(a.type) && !isWeekendPart(a.type) && !isAVPart(a.type),
  );
  return (
    <div className="weekly-assignment-summary">
      <b>
        {t("general.week")}: {stringToLongLocaleDate(weekOf)}
      </b>
      {midweekAssignments.length > 0 && (
        <div>
          <p>{t("conganalysis.attendance.midweek")}</p>
          <ul>
            {midweekAssignments.map((a, i) => (
              <li key={i}>{getAssignmentLabel(a)}</li>
            ))}
          </ul>
        </div>
      )}
      {weekendAssignments.length > 0 && (
        <div>
          <p>{t("conganalysis.attendance.weekend")}</p>
          <ul>
            {weekendAssignments.map((a, i) => (
              <li key={i}>{getAssignmentLabel(a)}</li>
            ))}
          </ul>
        </div>
      )}
      {otherParts.length > 0 && (
        <div>
          <p>{t("general.other")}</p>
          <ul>
            {otherParts.map((a, i) => (
              <li key={i}>{getAssignmentLabel(a)}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
